import React from 'react';

/**
 * headless: apps/topmags/layouts/MainLayout/Footer/ResellerRatingsBadge.
 *
 * TopMags' own seal, not shared/components/ResellerRatingsBadge: that one is
 * DiscountMags', with seller 27560 hard-coded, and this is seller 823346 with its own
 * image. Parameterising the shared one on the seller would collapse the two, and is
 * worth doing on its own rather than inside this port.
 */
export default function ResellerRatingsBadge() {
  return (
    <a
      className="flex justify-center my-2 md:my-0"
      href="https://www.resellerratings.com"
      target="_blank"
      rel="noreferrer"
      onClick={(event) => {
        event.preventDefault();
        window.open(
          'https://seals.resellerratings.com/landing.php?seller=823346',
          'resellerratings',
          'height=760,width=780,scrollbars=1'
        );
      }}
    >
      <img
        src="https://www.topmags.com/resources/topmags/images/reseller-ratings.png"
        alt="ResellerRatings"
        width={162}
        height={32}
        className="block border-0 w-[162px] h-[32px]"
      />
    </a>
  );
}
